import './antButton.less';

import React, { ForwardedRef, forwardRef } from 'react';
import { observer } from 'mobx-react';
import classnames from 'classnames';

import { Button, ButtonProps } from 'antd';

export interface AntButtonProps extends ButtonProps {
	width?: number;
}

export const AntButton = observer(
	forwardRef((props: AntButtonProps, ref: ForwardedRef<any>) => {
		const { style, className, width, ...restProps } = props;

		const classNames = React.useMemo(() => classnames(className, 'ceeview-ant-btn'), [className]);

		const styleActual = React.useMemo(() => {
			const result = { ...(style ?? {}) };

			if (width != null) {
				result.width = width + 'px';
			}

			return result;
		}, [style, width]);

		return <Button ref={ref} className={classNames} style={styleActual} {...restProps} />;
	}),
);
